import Backbone from 'backbone';

const _ = require('lodash');
const ajax = require('sma.common/ajax');
const Dropdown = require('sma.admin/components/dropdowns/dropdown');
const modals = require('sma.common/components/modals');
const Grid = require('sma.admin/components/grid');
const ApplicationPreviewBase = require('sma.common/preview').ApplicationPreviewBase;
const DownloadModal = require('sma.common/downloads').DownloadModal;
const reviewModalHeaderTemplate = require('sma.reviewer/partials/reviewmode_review_modal_header.mustache');
const completionModalTemplate = require('sma.reviewer/partials/completion_modal.mustache');
const highlightTemplate = require('sma.reviewer/partials/application_highlight.mustache');

class ReviewMode extends Backbone.View {
	get events() {
		return {
			'click .sma-js-reviewmode-fullscreen': 'maximizeReviewPanel',
			'click .sma-js-reviewmode-smallscreen': 'minimizeReviewPanel',
			'click .sma-js-reviewmode-tab': 'switchTab',
			'click .sma-js-note-tab': 'renderApplicationNotes',
			'change .sma-js-application-note-container': 'updateNotes',
			'click .sma-js-reviewer-reviewmode-alist-toggle': 'showAssignments',
			'click .sma-js-reviewer-instructions': 'showInstructions',
			'click .sma-js-clear-note': 'clearNote',
			'click .sma-js-review-member': 'memberClicked',
			'click .sma-js-review-preview': 'previewReview',
			'click .sma-js-add-note-btn': 'showNoteForm',
			'click .sma-js-download-application': 'downloadApplication',
			'click .sma-js-report-conflict': 'reportConflict',
			'click .sma-js-organization-profile': 'showOrganizationProfile',
		};
	}

	get $topbar() {
		return $('.sma-topbar');
	}

	get $footer() {
		return $('.sma-footer');
	}

	get $formContainer() {
		return this.element.find('.sma-reviewer-reviewmode-form-container');
	}

	get $formHeader() {
		return this.element.find('.sma-reviewer-reviewmode-form-header');
	}

	get $submissionPanel() {
		return this.element.find('.sma-js-submission-panel');
	}

	get $reviewPanel() {
		return this.element.find('.sma-js-review-panel');
	}

	get $panelDrag() {
		return this.element.find('.sma-js-panel-drag');
	}

	get $panelContainer() {
		return this.element.find('.sma-js-panel-container');
	}

	getTotalPanelWidth() {
		return this.$panelContainer.width();
	}

	switchTab(e) {
		const target = $(e.currentTarget);
		this._switchTab(target);
	}

	_switchTab(tabElement) {
		$(tabElement.attr('href')).show().siblings().hide();
		tabElement.addClass('active').parent().siblings().children()
			.removeClass('active');
		const nextButton = $('#sma-next-button');
		const previousButton = $('#sma-previous-button');

		this.updateButtonUrl(nextButton, tabElement.attr('href'));
		this.updateButtonUrl(previousButton, tabElement.attr('href'));
	}

	updateButtonUrl(button, newUrl) {
		if (button && button.attr('href')) {
			let url = button.attr('href');
			if (url.match('#')) {
				url = url.split('#')[0];
			}

			url += newUrl;
			button.attr('href', url);
		}
	}

	resetPanelWidth() {
		this.$submissionPanel.width('50%');
		this.$reviewPanel.width('50%');
	}

	windowResize() {
		if (this.reviewState === this.REVIEW_STATE.NORMAL) {
			this.resetPanelWidth();
		} else if (this.reviewState === this.REVIEW_STATE.MAXIMIZED) {
			this.$reviewPanel.width(this.getTotalPanelWidth() * 0.8);
			$('.sma-reviewer-reviewmode-form-container').height(
				$('.sma-reviewer-reviewmode-panel-form').height() - 140,
			);
		} else {
			this.$submissionPanel.width(this.getTotalPanelWidth());
		}
	}

	startDrag(e, that) {
		that.starting_x = e.clientX;
		that.starting_width = that.$submissionPanel.width();
		$(document).on('mousemove', function (e) { that.doDrag(e, that); });
		$(document).on('mouseup', function (e) { that.stopDrag(e, that); });

		that.$formContainer.find('iframe').css('pointer-events', 'none');
	}

	doDrag(e, that) {
		const totalWidth = this.getTotalPanelWidth();
		const width = (that.starting_width + e.clientX - that.starting_x);
		const smallestWidth = 375;

		if (width < smallestWidth || (totalWidth - width) < smallestWidth
			|| width >= totalWidth * 0.75 || width <= totalWidth * 0.25) {
			return;
		}

		that.$submissionPanel.width(width);
		that.$reviewPanel.width((totalWidth - width - 16));
	}

	stopDrag(e, that) {
		$(document).off('mousemove').off('mouseup');
		that.$formContainer.find('iframe').removeAttr('style');
	}

	resetReviewPanel() {
		this.reviewState = this.REVIEW_STATE.NORMAL;

		$('.sma-reviewer-reviewmode-panel-form').removeClass('focus');
		this.$reviewPanel.removeClass('minimized');

		$('.sma-reviewer-reviewmode-form-container').show();
		$('.sma-reviewer-reviewmode-form-save-btns').show();
		$('.sma-js-panel-drag').show();

		this.resetPanelWidth();

		$('.sma-reviewer-reviewmode-form-container').css('height', '');
		$('.sma-reviewer-modal-backdrop').remove();
	}

	minimizeReviewPanel() {
		if (this.reviewState === this.REVIEW_STATE.MINIMIZED) {
			$('.sma-js-review-minimize')
				.addClass('ui-1_bold-delete')
				.removeClass('ui-2_webpage');

			this.resetReviewPanel();
			return;
		}

		$('.sma-js-review-minimize')
			.removeClass('ui-1_bold-delete')
			.addClass('ui-2_webpage');

		$('.sma-js-review-maximize')
			.addClass('arrows-1_fullscreen-double-74')
			.removeClass('ui-2_webpage');

		this.resetReviewPanel();
		this.reviewState = this.REVIEW_STATE.MINIMIZED;

		const width = Math.floor(this.getTotalPanelWidth());
		this.$submissionPanel.width(width);
		this.$reviewPanel.width(0);

		$('.sma-js-panel-drag').hide();
		this.$reviewPanel.addClass('minimized');
		this.$formContainer.removeAttr('style').hide();
		this.$formContainer.parent();
	}

	maximizeReviewPanel() {
		if (this.reviewState === this.REVIEW_STATE.MAXIMIZED) {
			$('.sma-js-review-maximize')
				.addClass('arrows-1_fullscreen-double-74')
				.removeClass('ui-2_webpage');

			this.resetReviewPanel();
			return;
		}

		$('.sma-js-review-maximize')
			.removeClass('arrows-1_fullscreen-double-74')
			.addClass('ui-2_webpage');

		$('.sma-js-review-minimize')
			.addClass('ui-1_bold-delete')
			.removeClass('ui-2_webpage');

		this.resetReviewPanel();
		this.reviewState = this.REVIEW_STATE.MAXIMIZED;

		$('.sma-reviewer-reviewmode-panel-form').addClass('focus');

		$('body').append(
			$('<div></div>', {
				class: 'modal-backdrop sma-reviewer-modal-backdrop',
			}),
		);

		this.$reviewPanel.width(this.getTotalPanelWidth() * 0.8);

		$('.sma-reviewer-reviewmode-form-container')
			.height($('.sma-reviewer-reviewmode-panel-form').height() - 140);
	}

	renderApplicationNotes() {
		this.notes = new sma.ApplicationNotes({
			element: $('#sma-js-notes-tab'),
			submission: this.submission,
			is_reviewer: 1,
		});
	}

	updateNotes() {
		const notes = $('.sma-js-application-note-container').find('div.sma-js-note-container');
		const count = notes.length;
		const string = gettext('Notes') + ' (' + count + ')';
		$('.sma-js-note-count').text(string);
	}

	showNoteForm(e) {
		e.preventDefault();
		$('.sma-js-review-note-form').show();
		$('.sma-js-add-note-btn').hide();
	}

	showAssignments(e) {
		this.alist.toggle();
	}

	showInstructions(e) {
		e.preventDefault();

		ajax.get({
			url: $(e.currentTarget).attr('href'),
			callback: response => {
				let content = $('<div></div>').html(response.instructions || gettext('There are no instructions for this stage.'));

				new modals.ContentModal(content, {
					destroyOnClose: true,
					autoShow: true,
					title: gettext('Instructions'),
				});
			}
		});
	}

	clearNote(e) {
		e.preventDefault();
		$('#notes').find('#id_content').val('');
		$('.sma-js-review-note-form').hide();
		$('.sma-js-add-note-btn').show();
	}

	memberClicked(e) {
		let target = $(e.currentTarget).data('user-id');

		$('.sma-js-review-member').removeClass('selected');
		$('.sma-js-review-member[data-user-id="' + target + '"]').addClass('selected');

		$('.sma-js-review-member-metadata').hide();
		$('.sma-js-review-member-metadata[data-user-id="' + target + '"]').show();
	}

	previewReview(e) {
		e.preventDefault();

		const reviewId = $(e.currentTarget).data('review-id');

		let url = reverse('submission-taskrecord-preview', {
			submission_id: this.submission,
			task_record_id: reviewId,
		});

		url += '?no_task_header=1&no_stage_header=1';

		const context = {
			reviewer: {},
			stage: {},
			strings: {
				score: gettext('Score:'),
				rating: gettext('Rating'),
				completedOn: gettext('Completed on:'),
			},
		};

		for (let review of this.reviews) {
			for (let reviewer of review.reviewers) {
				if (reviewer.id == reviewId) {
					context.reviewer = reviewer;
					context.stage = review;
					break;
				}
			}
		}

		new modals.AjaxURLModal(url, {
			autoShow: true,
			size: 'lg',
			destroyOnClose: true,
			bodyClass: 'sma-reviewer-modal',
			headerTemplate: reviewModalHeaderTemplate,
			headerContext: context
		});
	}

	downloadApplication() {
		return new DownloadModal({
			title: gettext('Download options'),
			submission_ids: [this.submission],
			from_round_id: this.round,
		});
	}

	reportConflict() {
		const reportConflictModal = new modals.AjaxFormModal({
			destroyOnClose: true,
			autoShow: true,
			size: 'lg',
		});

		const modalContent = new modals.AjaxFormContent(
			reverse('reviewers-report-conflict', {
				submission_id: this.submission,
			}),
			{
				title: gettext('Conflict of interest'),
				buttons: [{
					label: gettext('Cancel'),
					cls: 'btn btn-link btn-loud',
					handler: () => { reportConflictModal.hide(); },
				}, {
					label: gettext('OK'),
					cls: 'btn btn-primary btn-loud',
					handler: (modal) => {
						const form = modal.modalBody.find('form');
						// Always redirect to assignments list after COI so we never land on a
						// now-conflicted submission (same applicant) which would 404.
						form.find('#id_next').val('home');
						form[0].submit();
					},
				}],
			},
		);

		reportConflictModal.addToStack(
			'ConflictOfInterest',
			modalContent,
		);
	}

	okToReset() {
		let resettable;
		if (this.review_completion === 'individually') {
			if (this.allow_review_editing) {
				resettable = this.allow_review_editing;
			} else if (this.reviews && this.reviews.length > 0) {
				resettable = this.reviews[0].completed !== 1;
			}
		} else {
			resettable = !this.stageSubmitted;
		}
		return resettable;
	}

	renderReviewMenu() {
		const items = [{
			name: 'download',
			text: gettext('Download my review'),
			action: () => {
				ajax.post({
					url: reverse('download-redirect'),
					data: {
						submission_ids: [this.submission],
						stage_ids: [this.round],
						task_record_ids: [this.task_record],
						from_round_id: this.round
					},
					alertOnSuccess: false,
					callback: (response) => {
						if (response.url) {
							window.open(response.url, '_blank');
						}
					},
				});
			},
		}];

		if (this.okToReset()) {
			items.unshift({
				name: 'reset',
				text: gettext('Reset my review'),
				action: () => {
					new modals.Confirm(
						gettext('Reset selected reviews'),
						gettext('Resetting reviews will remove all review data for the selected applications. This cannot be undone.'),
						() => {
							ajax.post({
								url: reverse('reviewers-reset-task', {
									'award_id': this.award,
									'round_id': this.round,
								}),
								data: {
									submissions: [this.submission],
								},
								callback: () => {
									$('#sma-js-review-form-iframe').attr('src', function (i, val) { return val; });
								},
							});
						},
					);
				},
			});
		}

		const menu = new Dropdown({
			items,
			title: '<i class="nc-icon-mini ui-2_menu-dots"></i>',
			noCaret: true,
			btnclass: 'btn-link',
			rightAligned: true,
		}).$el.addClass('dropdown');

		$('.sma-js-review-menu').html(menu);
	}

	showOrganizationProfile(e) {
		e.preventDefault();

		ajax.get({
			url: $(e.currentTarget).attr('href'),
			dataType: 'html',
			callback: (response) => {
				let content = $('<div></div>').html(response);

				new modals.ContentModal(content, {
					destroyOnClose: true,
					size: 'lg',
					autoShow: true
				});
			}
		});
	}

	render() {
		this.resetPanelWidth();
		this.renderApplicationPreview();
		this.renderReviewMenu();

		if (this.showReviews) {
			this.renderReviews();
		}
	}

	renderApplicationPreview() {
		this.applicationPreview = new ApplicationPreview({
			previewUrl: 'submission-reviewer-stage-preview',
			previewEl: $('.sma-js-application-preview'),
			stageIds: this.applicantStages,
			application: this.submission,
			fromRound: this.round,
		});
	}

	renderReviews() {
		this.reviewsPreview = new ReviewsTab({
			element: $('#reviews'),
			url: reverse('reviewers-reviews-tab', {
				award_id: this.award,
				round_id: this.round,
				submission_id: this.submission,
			}),
		});

		this.reviewsPreview.render();
	}

	showCompleteModal() {
		let topText = '';
		let bottomText = '';

		const buttons = [{
			label: gettext('Cancel'),
			cls: 'btn btn-link sma-automation-modal-cancel',
			handler: (modal) => {
				modal.hide();
			},
		}];

		const assignmentsUrl = reverse('reviewers-assignments-list', {
			award_id: this.award,
			round_id: this.round,
		});

		const submitUrl = reverse('reviewers-assignments-submit', {
			award_id: this.award,
			round_id: this.round,
		});

		const submitPageUrl = reverse('reviewers-assignments-submit-page', {
			award_id: this.award,
			round_id: this.round,
		});

		const needsSubmitUrl = reverse('reviewers-assignments-needs-submit', {
			award_id: this.award,
			round_id: this.round,
		});

		let needsSubmit = true;

		const options = {
			url: needsSubmitUrl,
			callback: (response) => {
				needsSubmit = response.needs_submit;

				let { completionMessage } = this;
				if (needsSubmit) {
					topText = gettext(
						`You have completed reviewing all of your assigned applications! To complete the review process, you are required to submit your reviews`
					);
					bottomText = gettext('Would you like to submit your reviews?');
					completionMessage = '';

					buttons.push({
						label: gettext('Review & submit'),
						cls: 'btn btn-default sma-automation-review-submit',
						handler: () => {
							window.top.location.href = assignmentsUrl;
						},
					}, {
						label: gettext('Submit'),
						cls: 'btn btn-primary sma-automation-submit',
						handler: () => {
							const submitOptions = {
								url: submitUrl,
								headers: {
									Accept: 'application/json'
								},
								callback: () => {
									window.top.location.href = submitPageUrl;
								},
							};
							ajax.post(submitOptions);
						},
					});
				} else {
					topText = gettext('You have completed reviewing all of your assigned applications!');
					buttons.push({
						label: gettext('Return to assignments'),
						cls: 'btn btn-primary sma-automation-return-assignments',
						handler: () => {
							window.top.location.href = assignmentsUrl;
						},
					});
				}

				const content = completionModalTemplate({
					topText,
					bottomText,
					completionMessage,
				});

				new modals.ContentModal(content, {
					autoShow: true,
					destroyOnClose: true,
					buttons,
					size: 'lg',
				});
			},
		};

		ajax.get(options);
	}

	fetchApplicationSummaryData() {
		// Reuse row data from assignment table when available (avoids redundant API call)
		const cacheKey = `sma.reviewer.tableRowCache.${this.award}.${this.round}`;
		try {
			const cached = sessionStorage.getItem(cacheKey);
			if (cached) {
				const cache = JSON.parse(cached);
				const rowData = cache[String(this.submission)];
				if (rowData) {
					this.updateApplicationSummary(rowData);
					delete cache[String(this.submission)];
					sessionStorage.setItem(cacheKey, JSON.stringify(cache));
					return;
				}
			}
		} catch (e) {
			// Fall through to API call on parse or storage error
		}

		const url = `${reverse('api-smapply-applicationtable-detail', {
			award_id: this.award,
			id: this.submission
		})}?round_id=${this.round}`;

		ajax.get({
			url,
			callback: (response) => {
				this.updateApplicationSummary(response);
			},
		});
	}

	/**
	 * Pre-fetch previous and next application data in the background so that when the
	 * reviewer clicks next/previous, the Summary tab can use cached data and load quickly.
	 * Failures are silent; the next page will fall back to the detail API.
	 */
	preFetchAdjacentApplications() {
		if (!this.previousID && !this.nextID) {
			return;
		}
		const cacheKey = `sma.reviewer.tableRowCache.${this.award}.${this.round}`;
		const idsToFetch = [];
		if (this.previousID && String(this.previousID) !== String(this.submission)) {
			idsToFetch.push(this.previousID);
		}
		if (this.nextID && String(this.nextID) !== String(this.submission)) {
			idsToFetch.push(this.nextID);
		}
		idsToFetch.forEach((submissionId) => {
			const url = `${reverse('api-smapply-applicationtable-detail', {
				award_id: this.award,
				id: submissionId,
			})}?round_id=${this.round}`;
			ajax.get({
				url,
				callback: (response) => {
					try {
						const cached = sessionStorage.getItem(cacheKey);
						const cache = cached ? JSON.parse(cached) : {};
						cache[String(submissionId)] = response;
						sessionStorage.setItem(cacheKey, JSON.stringify(cache));
					} catch (e) {
						// Ignore storage/parse errors
					}
				},
				onFail: () => {
					// Don't show error; next page will fall back to detail API
				},
			});
		});
	}

	updateApplicationSummary(responseData) {
		const data = [];

		if (this.highlights.length === 0) {
			$('#tab-summary').parents('.nav-item:first').hide();
			this._switchTab($('#tab-application'));
		}

		this.highlights.forEach((tableHeader) => {
			const path = tableHeader.key.split('__');

			let obj = responseData;

			if (path[0] === 'recommender_responses') {
				if (_.hasIn(obj, path.join('.'))) {
					let recommenderResponses = _.get(obj, path.join('.'));

					recommenderResponses = recommenderResponses.map(response => (
						`${response.recommender}: ${response.response}`
					)).join('<br>');

					_.set(obj, path.join('.'), recommenderResponses);
				}
			}

			if (path[0] === 'reviewer_responses') {
				if (_.hasIn(obj, path.join('.'))) {
					let reviewerResponses = _.get(obj, path.join('.'));

					reviewerResponses = reviewerResponses.map(response => (
						`${response.reviewer}: ${response.response}`
					)).join('<br>');

					_.set(obj, path.join('.'), reviewerResponses);
				}
			}

			if (path[0] === 'applicant') {
				if (_.hasIn(obj, path.join('.'))) {
					let applicantName = _.get(obj, path.join('.'));

					if (_.get(obj, 'logo')) {
 						applicantName = `<div className="d-flex align-items-center">
 								<img className="mr-1" src=${_.get(obj, 'logo')} width="36px"></img>
 								<span>${applicantName}</span>
 							</div>`;
 					}

					_.set(obj, path.join('.'), applicantName);
				}
			}

			if (path[0] === 'notes') {
				if (_.hasIn(obj, path.join('.'))) {
					let notes = _.get(obj, path.join('.'));
					notes = `${notes.total || 0} (${notes.new || 0} new)`;
					_.set(obj, path.join('.'), notes);
				}
			}

			if (path[0] === 'collaborators') {
				_.set(obj, path.join('.'), obj[path[0]].map(row => row[path[1]]).join(', '));
			}

			for (const currentPath of path) {
				if (obj.hasOwnProperty(currentPath)) {
					obj = obj[currentPath];
				} else {
					obj = '';
				}
			}
			let value = _.escape(obj);
			// <br> tag should break the line
			value = _.replace(value, new RegExp('&lt;br&gt;', 'g'), '<br>');
			value = _.replace(value, new RegExp('&lt;br/&gt;', 'g'), '<br/>');

			if (path[0] === 'applicant') {
				value = obj;
			}

			data.push({
				label: tableHeader.label,
				value: value,
			});
		});

		const content = highlightTemplate({
			data,
		});

		const applicationSummaryContainer = $('.sma-js-application-summary');
		applicationSummaryContainer.append($(content));
	}

	initialize(config) {
		this.element = $('body');
		this.setElement(this.element[0]);

		this.task_record = config.task_record;
		this.award = config.award;
		this.round = config.round;
		this.round_name = config.round_name;
		this.submission = config.submission;
		this.stages = config.stages;
		this.allow_review_editing = config.allow_review_editing;
		this.reopen_after_submit = config.reopen_after_submit;
		this.review_completion = config.review_completion;
		this.stageSubmitted = config.stageSubmitted || false;
		this.reviews = config.reviews;
		this.nextID = config.nextID;
		this.previousID = config.previousID;
		this.completionMessage = config.completionMessage || '';
		this.applicantStages = config.applicantStages || [];
		this.showReviews = config.showReviews || false;
		this.highlights = config.highlights;

		this.fetchApplicationSummaryData();
		this.preFetchAdjacentApplications();

		this.REVIEW_STATE = {
			NORMAL: 0,
			MAXIMIZED: 1,
			MINIMIZED: 2,
		};

		// Window resize isn't working in events()
		$(window).on('resize', () => {
			this.windowResize();
		});
		$('body').on('reviewsComplete', $.proxy(this.showCompleteModal, this));
		// Set event here to pass it "that"
		this.$panelDrag.on('mousedown', (e) => {
			this.startDrag(e, this);
		});

		this.reviewState = this.REVIEW_STATE.NORMAL;

		this.render();

		const url = document.location.toString();

		if (url.match('#')) {
			const tabType = url.split('#')[1];
			const tabId = `#tab-${tabType}`;
			const tab = $(tabId);

			$(tab).tab('show');
			$(tab.attr('href')).show().siblings().hide();
			tab.addClass('active').parent().siblings().children()
				.removeClass('active');
			this.updateButtonUrl($('#sma-next-button'), `#${tabType}`);
			this.updateButtonUrl($('#sma-previous-button'), `#${tabType}`);
		}
	}
}

class ReviewsTab extends Backbone.View {
	render() {
		ajax.get({
			url: this.url,
			dataType: 'html',
			callback: (response) => {
				this.element.html(response);
				const reviews = this.element.find('[data-reviews]').data('reviews');

				for (let round of reviews) {
					let columns = [
						{
							id: 'reviewer',
							name: gettext('Reviewer'),
							formatter: (item) => {
								if (item.photo) {
									return `<img class="sma-avatar-sm" src='${item.photo}' /> ${item.reviewer}`;
								}
								return `<span class="sma-avatar-sm">
									${item.initials}</span> ${item.reviewer}`;
							},
						}, ...(round.scores_visible ? [{
							id: 'score',
							name: gettext('Score'),
							formatter: item => (item.score ? `${item.score}` : '—'),
						}] : []), {
							id: 'preview',
							name: 'Completed review',
							formatter: (item) => {
								if (!item.id) return '—';
								return `<a href="#" class="sma-js-review-preview" data-review-id="${item.id}">View</a>`;
							},
						},
					];
					new ReviewGrid({
						element: $(`#sma-js-reviews-${round.id}`),
						columns: columns,
						results: {
							count: round.reviewers.length,
							results: round.reviewers
						}
					});
				}
			}
		});
	}

	initialize(config) {
		this.element = config.element;
		this.url = config.url;
		this.setElement(this.element[0]);
	}
}

let ReviewGrid = Grid.Grid.extend({
	showToolbar: false,
	showTitlebar: false,
	showSearchBar: false,
	showFooter: false,
	showColumnDropSelect: false,
	showSelectorColumn: false,
});

class ApplicationPreview extends ApplicationPreviewBase {
	constructor(config) {
		super(config);
	}
}

module.exports = {
	ApplicationPreview,
	ReviewMode,
	ReviewsTab,
};
